<template>
  <section class="login">
    <form @submit.prevent="saveSmsCode">
      <fieldset class="card small">
        <div class="grid-x grid-padding-x">
          <div class="cell" v-if="autologout">
            <div class="panel center error">Du har automatiskt blitt logget ut</div>
          </div>

          <div class="cell">
            <div style="text-align: center; margin: 15px 0px;">
              <h2 style="color:#4758A6; font-size: 1.5rem;">
                {{times.minutes}} : {{times.seconds}}
              </h2>
            </div>
          </div>

          <div class="cell" v-show="error">
            <div class="panel center error">
              {{errorMsg}}
            </div>
          </div>

          <div class="cell" v-show="success">
            <div class="panel center success">
              {{successMsg}}
            </div>
          </div>

          <div class="cell" v-if="avantiEnv === 'staging'">
            <div style="color: red; margin-bottom: 1rem;">STAGING</div>
          </div>

          <div class="cell">
            <label for="smscode">Du har mottatt en kode på din mobiltelefon. Tast inn koden her:</label>
            <div class="input-container text">
              <input type="text" id="smscode" name="smscode" v-model="smsCode" required>
            </div>
          </div>

          <input type="hidden" id="userid" name="userid" v-model="userId">

          <div class="cell shrink">
            <button v-if="!processing" type="submit" name="save" value="save" class="button primary submit large">Logg inn</button>
            <button v-else type="submit" name="save" value="save" class="button primary loading">Logger inn<span class="loader-spinner"></span></button>
          </div>

          <div class="cell auto">
            <!--a href="login-password-forgot.html" class="button primary submit large transparent">Glemt passord?</a-->
          </div>

          <div class="cell shrink">
            <button v-if="!processing2" type="button" @click="renewSmsCode" name="renew" value="renew" class="button primary submit large">Send ny SMS-kode</button>
            <button v-else type="button" name="renew" value="renew" class="button primary loading">Send ny SMS-kode<span class="loader-spinner"></span></button>
          </div>
        </div>
      </fieldset>
    </form>

    <div class="login-footer">
      <div class="nav-logo"></div>
      <h1 v-if="avantiEnv === 'production'">Blomqvist Avanti</h1>
      <h1 v-if="avantiEnv === 'local'">Blomqvist Avanti (local)</h1>
      <h1 v-if="avantiEnv === 'staging'" style="color: red">Blomqvist Avanti (staging)</h1>
      <span class="version">Version 0.1.8</span>
    </div>
  </section>
</template>

<script>
import { AUTH_REQUEST_2FA, AUTH_REQUEST_2FA_RENEW } from '../../store/actions/auth'
import { mapGetters } from 'vuex'

export default {
  name: 'UserVerify',
  data () {
    return {
      smsCode: '',
      userId: '',
      expire: false,
      error: false,
      errorMsg: 'Feil mobilkode',
      success: false,
      successMsg: '',
      processing: false,
      processing2: false,
      autologout: false,
      times: {
        days: '00',
        hours: '00',
        minutes: '00',
        seconds: '00'
      },
      locale: 'en-US',
      localeOption: {
        minimumIntegerDigits: 2,
        useGrouping: false
      },
      timeinterval: '',
      play: 0
    }
  },
  watch: {
    expire: function (newVal) {
      this.play = 1
      this.timeinterval = setInterval(this.countDonw, 1000)
    }
  },
  mounted () {
    window.jQuery('#username').focus()

    if (sessionStorage.autologout) {
      sessionStorage.removeItem('autologout')
      this.autologout = true
    }

    if (localStorage.getItem('user-2fa')) {
      this.userId = localStorage.getItem('user-2fa')
    }

    if (localStorage.getItem('expire-2fa')) {
      this.expire = localStorage.getItem('expire-2fa')
    }
  },
  methods: {
    saveSmsCode: function () {
      if (this.processing) {
        return
      }
      this.autologout = false
      this.processing = true
      this.error = false
      this.success = false

      const { smsCode, userId } = this
      let formData = {
        'sms_code': smsCode,
        'user_id': userId
      }

      this.$store.dispatch(AUTH_REQUEST_2FA, formData)
        .then((response) => {
          this.expire = response.data.expire || ''
          this.$router.push('/dashboard')
        })
        .catch((error) => {
          this.errorMsg = error.response.data.message || error.message
          this.error = true
        })
        .then(() => {
          this.processing = false
        })
    },

    renewSmsCode: function () {
      if (this.processing2) {
        return
      }
      this.processing2 = true
      this.error = false
      this.success = false

      const { userId } = this
      let formData = {
        'renew': true,
        'user_id': userId
      }

      this.$store.dispatch(AUTH_REQUEST_2FA_RENEW, formData)
        .then((response) => {
          this.processing2 = false
          this.success = true
          this.successMsg = response.data.message || ''
          this.expire = response.data.expire || ''
          this.$router.push('/verify')
        })
        .catch((error) => {
          this.errorMsg = error.response.data.message || error.message
          this.error = true
        })
        .then(() => {
          this.processing2 = false
        })
    },
    countDonw: function () {
      if (this.play === 1) {
        this.getTimeRemaining()
      } else {
        clearInterval(this.timeinterval)
      }
    },
    getTimeRemaining: function () {
      let expire = this.expire || localStorage.getItem('expire-2fa')
      let startDate = new Date(expire)
      let endDate = new Date()
      let t = Date.parse(startDate) - Date.parse(endDate)
      if (t >= 0) {
        let seconds = Math.floor(t / 1000 % 60) // seconds
        let minutes = Math.floor(t / 1000 / 60 % 60) // minutes
        let hours = Math.floor(t / (1000 * 60 * 60) % 24) // hours
        let days = Math.floor(t / (1000 * 60 * 60 * 24)) // days

        this.times.seconds = seconds.toLocaleString(this.locale, this.localeOption)
        this.times.minutes = minutes.toLocaleString(this.locale, this.localeOption)
        this.times.hours = hours.toLocaleString(this.locale, this.localeOption)
        this.times.days = days.toLocaleString(this.locale, this.localeOption)
      } else {
        let resetValue = 0
        this.times.days = this.times.hours = this.times.minutes = this.times.seconds = resetValue.toLocaleString(this.locale, this.localeOption)
        this.play = 0
      }
    }
  },
  created: function () {
    this.play = 1
    this.timeinterval = setInterval(this.countDonw, 1000)
  },
  computed: {
    ...mapGetters(['isLoggedIn'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Guest/UserVerify.vue